import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=381db961"
import script from "./CommentDialog.vue?vue&type=script&lang=js"
export * from "./CommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports